// src/InvoiceCustomization/pages/table-editor.jsx (or .js)
import React, { useEffect } from 'react';
import { TableProvider, useTable } from '../context/TableContext.js';
import Header from '../components/TableEditor/Header.js';
import Sidebar from '../components/TableEditor/Sidebar.js';
import A4Canvas from '../components/TableEditor/A4Canvas.js';
import StatusBar from '../components/TableEditor/StatusBar.js';
import ExportModal from '../components/TableEditor/ExportModal.js';
import ProductTableWizard from '../components/TableEditor/ProductTableWizard.js';
import sampleBillingData from "../Samples/BillingSample.js";
import samplePurchaseCreditNote from "../Samples/DebitNote.js";
import sampleDeliveryNote from "../Samples/DeliveryNote.js";
import sampleGRNData from "../Samples/GRNData.js";
import samplePurchaseInvoice from "../Samples/Purchase_invoice.js";
import samplePurchaseOrder from "../Samples/PurchaseOrder.js";
import samplePurchaseReturn from "../Samples/PurchaseReturn.js";
import sampleSalesOrder from "../Samples/SaleOrder.js";
import SalesInvoice from '../Samples/SalesInvoice.js';
import SalesReturn from '../Samples/SalesReturn.js';
import sampleCreditNote from "../Samples/CreditNote.js";
function buildBillingLabels(inv = {}, store = {}) {
  const keys = o => (o && typeof o === 'object') ? Object.keys(o) : [];
  const all = [
    ...keys(inv?.orderData),
    ...keys(store),
    ...keys(inv?.paymentData?.[0]),
  ];
  return Array.from(new Set(all.filter(Boolean))).sort();
}


function LabelsBootstrapper() {
  const { state,actions } = useTable();

  useEffect(() => {
    if (state.type === 'billing_invoice') {
      const invoice0 = sampleBillingData.InvoiceArray_sample?.[0];
      const store0 = sampleBillingData.storeDetailsResult_sample?.[0];
      const labels = buildBillingLabels(invoice0, store0);
      actions.setLabels(labels);
    } 
    else if (state.type === 'sales_order') {
      const invoice0 = sampleSalesOrder.SaleOrder_sample?.[0];
      const store0 = sampleBillingData.storeDetailsResult_sample?.[0];
      const labels = buildBillingLabels(invoice0, store0);
      actions.setLabels(labels);
    } 
    else if (state.type === 'delivery_note') {
      const invoice0 = sampleDeliveryNote.DeliveryNote_sample?.[0];
      const store0 = sampleBillingData.storeDetailsResult_sample?.[0];
      const labels = buildBillingLabels(invoice0, store0);
      actions.setLabels(labels);
    } 
    else if (state.type === 'sales_invoice') {
      const invoice0 = SalesInvoice.SaleInvoice_sample?.[0];
      const store0 = sampleBillingData.storeDetailsResult_sample?.[0];
      const labels = buildBillingLabels(invoice0, store0);
      actions.setLabels(labels);
    } 
    else if (state.type === 'sales_return') {
      const invoice0 = SalesReturn.SalesReturn_sample?.[0];
      const store0 = sampleBillingData.storeDetailsResult_sample?.[0];
      const labels = buildBillingLabels(invoice0, store0);
      actions.setLabels(labels);
    }
    else if (state.type === 'sales_credit_note') {
      const invoice0 = sampleCreditNote.CreditNoteData?.[0];
      const store0 = sampleBillingData.storeDetailsResult_sample?.[0];
      const labels = buildBillingLabels(invoice0, store0);
      actions.setLabels(labels);
    }
    else if (state.type === 'purchase_order') {
      const invoice0 = samplePurchaseOrder.PurchaseOrder_sample?.[0];
      const store0 = sampleBillingData.storeDetailsResult_sample?.[0];
      const labels = buildBillingLabels(invoice0, store0);
      actions.setLabels(labels);
    }
    else if (state.type === 'good_receipt_note') {
      const invoice0 = sampleGRNData.GRNData_1?.[0];
      const store0 = sampleBillingData.storeDetailsResult_sample?.[0];
      const labels = buildBillingLabels(invoice0, store0);
      actions.setLabels(labels);
    }
    else if (state.type === 'purchase_invoice') {
      const invoice0 = samplePurchaseInvoice.PurchaseInvoice_sample?.[0];
      const store0 = sampleBillingData.storeDetailsResult_sample?.[0];
      const labels = buildBillingLabels(invoice0, store0);
      actions.setLabels(labels);
    }
    else if (state.type === 'purchase_return') {
      const invoice0 = samplePurchaseReturn.PurchaseReturn_sample?.[0];
      const store0 = sampleBillingData.storeDetailsResult_sample?.[0];
      const labels = buildBillingLabels(invoice0, store0);
      actions.setLabels(labels);
    }
    else if (state.type === 'purchase_credit_note') {
      const invoice0 = samplePurchaseCreditNote.DebitNote_Sample?.[0];
      const store0 = sampleBillingData.storeDetailsResult_sample?.[0];
      const labels = buildBillingLabels(invoice0, store0);
      actions.setLabels(labels);
    }
    else {
      actions.setLabels([]);
    }
  }, [state.type]);

  return null;
}

export default function TableEditor() {
  return (
    <TableProvider>
      {/* Make the whole page a column that fills the viewport */}
      <LabelsBootstrapper/>
      <div className="flex flex-col h-screen">
        <Header />

        {/* This row fills the remaining height and allows children to scroll */}
        <div className="flex flex-1 min-h-0">
          <Sidebar />      {/* will be h-full of this row */}
          <A4Canvas />
        </div>

        <StatusBar />
        <ProductTableWizard />
        <ExportModal />
      </div>
    </TableProvider>
  );
}

